/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Override_Remove_ErrorInputs */



/**
* | output |
* | --- |
* | "Failed to remove override" |
*
* @param {Override_Remove_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const override_remove_error = /** @type {((inputs?: Override_Remove_ErrorInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Override_Remove_ErrorInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Échec du retrait de la modification")
	if (locale === "es") return /** @type {LocalizedString} */ ("Error al eliminar anulación")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Falha ao remover substituição")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rimozione sovrascrittura fallita")
	return /** @type {LocalizedString} */ ("Failed to remove override")
});